export const MapData=[
    {
     maptype:'Base Map Image',
     fileName:'xyz.jpg',
    },
    {
        maptype:'Floor Plan Image',
        fileName:'xyz.jpg',
       },
       {
        maptype:'Annoted Image',
        fileName:'xyz.jpg',
       },
       {
        maptype:'No GoZone Image',
        fileName:'xyz.jpg',
       },    
]
export const pickuplocations=[
    {
        locationName:'TRIPADVISOR',
        position:'77.7784,3.684,1.619',
        status:'off',  
    },
    {
        locationName:'TRIPADVISOR',
        position:'77.7784,3.684,1.619',
        status:'off',  
    }
]
export const dropofflocations=[
    {
        locationName:'B1',
        position:'77.7784,3.684,1.619',
        status:'off', 
        wandor:'on' 
    },
    {
        locationName:'B2',
        position:'77.7784,3.684,1.619',
        status:'off', 
        wandor:'off' 
    },
    {
        locationName:'B3',
        position:'77.7784,3.684,1.619',
        status:'off',
        wandor:'off'  
    },
    {
        locationName:'B3',
        position:'77.7784,3.684,1.619',
        status:'off',
        wandor:'off'  
    }
]
export const homelocation=[
    {
      locationName:'HOME1',
      position:'88.852,-11.202,-1.476',
      status:'off',
      assignrobot:[ 'ROVER003', 'ROVER003'], 
    },
    {
        locationName:'HOME1',
        position:'88.852,-11.202,-1.476',
        status:'off',
        assignrobot:[ 'ROVER003', 'ROVER003'], 
    },
    {
        locationName:'HOME1',
        position:'88.852,-11.202,-1.476',
        status:'off',
        assignrobot:[ 'ROVER003', 'ROVER003'], 
    },
    {
    locationName:'HOME1',
    position:'88.852,-11.202,-1.476',
    status:'off',
    assignrobot:[ 'ROVER003', 'ROVER003'], 
   }
]